<script setup lang="ts">
import { useRouter } from 'vue-router';
definePage({meta:{allowAnonymous:true}});
const router=useRouter();
onMounted(async()=>{ const ready=await provisionFleetBots(); await router.replace(ready?'/dashboard':'/login'); });
</script>
<template><div class="p-4 text-sm">Opening Beast Scalper V25…</div></template>
